import { inject } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

export const LOGGED_IN_GUARD: CanActivateFn = async (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Promise<boolean | UrlTree>((resolve) => {
    onAuthStateChanged(
      auth,
      (authState) => {
        if (!authState) return resolve(true);

        if (!authState['auth']?.currentUser) {
          return resolve(true);
        } else {
          return resolve(router.createUrlTree(['/dashboard']));
        }
      },
      (error) => {
        return resolve(true);
      },
    );
  });
};
